import { render, staticRenderFns } from "./h5RechargePageA.vue?vue&type=template&id=1a70c0e3&"
import script from "./h5RechargePageA.vue?vue&type=script&lang=js&"
export * from "./h5RechargePageA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports